import React from "react";
import { useSelector } from "react-redux";

import { i18, trb } from "@utilities";
import {
  InputFormField,
  SelectFormField,
  DateFormField
} from "@components/FormField/HookFormFields";
import { selectAvailableCountryOptions } from "@redux";
import { FullWidthInputWrapper, HalfWidthInputWrapper, StepperFormRow } from "@components";

export const ClientRep = ({ control }) => {
  const availableCountries = useSelector(selectAvailableCountryOptions);

  return (
    <StepperFormRow>
      <FullWidthInputWrapper>
        <p className="form-group-title">{trb(i18.Labels.ClientRep)}</p>
      </FullWidthInputWrapper>

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientRep.0.data.clientRepName"
          title={trb(i18.Labels.ClientRepName)}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientRep.0.data.clientRepSurname"
          title={trb(i18.Labels.ClientRepSurname)}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientRep.0.data.clientRepId"
          title={trb(i18.Labels.ClientRepId)}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <SelectFormField
          control={control}
          name="clientRep.0.data.clientRepRegCountry"
          title={trb(i18.Labels.ClientRepRegCountry)}
          options={availableCountries}
          optionsLabel="label"
          optionsValue="value"
          isSearchable
          defaultValue="LT"
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <DateFormField
          control={control}
          name="clientRep.0.data.clientRepBirthDate"
          title={trb(i18.Labels.ClientRepBirthDate)}
          maxDate={new Date()}
        />
      </HalfWidthInputWrapper>
    </StepperFormRow>
  );
};
